export default __webpack_public_path__ + "static/webb@2x-23c1a31ba80c9f3cdd7724c8870ee859.png";